import type { ReactNode } from 'react';
import './rahmen.css';

/**
 * Einheitlicher Seitenkopf (Auftrag Abschnitt 8):
 *
 *   Beleuchtung — Nachweis je Raum
 *   Nachweis der Beleuchtungsanforderungen nach DIN EN 12464-1
 *                                      Modellstand 17.09.2026
 *                                      [Neu berechnen] [...]
 *
 * "Nicht jede Seite muss alles anzeigen" - außer `titel` ist alles optional.
 * Die Brotkrumen stehen NICHT hier, sondern einmal im `AppShell` über dem
 * Inhalt: Sonst müsste jede der 147 Seiten sie selbst setzen, und wer es
 * vergisst, hinterlässt eine Seite ohne Orientierung.
 *
 * `children` nimmt die lokalen Reiter (`LocalTabs`) auf - sie gehören
 * unmittelbar unter den Titel und über den Inhalt (Abschnitt 7).
 */
export interface PageHeaderProps {
  titel: string;
  beschreibung?: string;
  /** Kurze Kennzahlen/Stände rechts über den Aktionen, z. B. "Modellstand …". */
  meta?: ReactNode;
  /** Primäre Aktion und Sekundäraktionen, rechtsbündig. */
  aktionen?: ReactNode;
  children?: ReactNode;
}

export function PageHeader({
  titel, beschreibung, meta, aktionen, children,
}: PageHeaderProps) {
  return (
    <header className="seitenkopf">
      <div className="seitenkopf-zeile">
        <div>
          <h1>{titel}</h1>
          {beschreibung && <p className="seitenkopf-beschreibung">{beschreibung}</p>}
        </div>
        {(meta || aktionen) && (
          <div>
            {meta && <div className="seitenkopf-meta">{meta}</div>}
            {aktionen && <div className="seitenkopf-aktionen">{aktionen}</div>}
          </div>
        )}
      </div>
      {children}
    </header>
  );
}
